import { render } from "./BuyDossardListeAttenteView.vue?vue&type=template&id=a61821b6"
import script from "./BuyDossardListeAttenteView.vue?vue&type=script&lang=js"
export * from "./BuyDossardListeAttenteView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__